import Api from '../../../api';
import store from '../../../store';

const fetchBatchInfoOverPeriod = async (data) => {
    return fetchInfo('/batch/GetBatchInfoOverPeriod', data);
};

const fetchBatchInfo = async (data) => {
    return fetchInfo('/batch/GetBatchInfo', data);
};

const fetchBatchIngredients = async (data) => {
    return fetchInfo('/batch/GetBatchIngredienstByBatchID', data);
    //return fetchInfo('/batch/GetBatchIngredientsByBatchID', data);
};

const fetchBatchIngredient = async (data) => {
    return fetchInfo('/batch/GetBatchIngredient', data);
};

const fetchBatchQualityPrediction = async (data) => {
    return fetchInfo('/batch/GetBatchQualityPrediction', data);
};

const fetchAlternativeCheeseTypes = async (data) => {
    return fetchInfo('/batch/GetAlternativeCheeseTypes', data);
};

const addBatchIngredients = async (data) => {
    return await Api(store).put('/batch/StoreBatchIngredients', data);
};

const deleteBatchIngredient = async (data) => {
    //return await Api(store).delete('/batch/RemoveBatchIngredient', data);
    return deleteInfo('/batch/RemoveBatchIngredient', data);
};

const fetchBatch = async (data) => {
    return fetchInfo('/batch/GetBatch', data);
};

const deleteBatch = async (data) => {
    return deleteInfo('/batch/RemoveBatch', data);
};

const moveBatchToEnd = async (data) => {
    return storeInfo('/batch/moveBatchToEnd', data);
};

// data = batchid, productionStarted
// output is float
const destroyBatch = async (data) => {
    return deleteInfo('/batch/DeleteBatch', data);
};

const addBatches = async (data) => {
    // return await Api(store).put('/batch/AddBatches', data);
    return storeInfo('/batch/AddBatches', data);
};

// data =  BatchAssignSalesOrderModel
const assignSalesOrder = async (data) => {
    return await Api(store).put('/batch/AssignSalesOrder', data);
};

// data = UpdateBatchModel
const updateBatch = async (data) => {
    return await Api(store).put('/batch/UpdateBatch', data);
};

// data = InBrineModel
const updateBatchInBrine = async (data) => {
    return await Api(store).put('/batch/BatchInBrine', data);
};

const setCheeseMarks = async (data) => {
    return await Api(store).put('/batch/SetCheeseMarks', data);
};

const repairCheeseMarks = async (data) => {
    return await Api(store).put('/batch/RepairCheeseMarks', data);
};

// data = batchid
// output is InBrineModel
const fetchBatchInbrineAmounts = async (data) => {
    return fetchInfo('/batch/GetBatchInBrineAmounts', data);
};

// data = batchid
// output is InBrineModel
const fetchBatchDefaults = async (data) => {
    return fetchInfo('/batch/GetBatchDefaults', data);
};

// data = milkGroupTypeID,  date
// output is float
const fetchMilkusagefactor = async (data) => {
    return fetchInfo('/Ingredient/GetMilkusagefactor', data);
};

const fetchMilkInfoForDay = async (data) => {
    return fetchInfo('/batch/GetPlannedMilkTypes', data);
};

const fetchStarterSubtypesForDay = async (data) => {
    return fetchInfo('/batch/GetPlannedStarterSubTypes', data);
};

// data = batchID
// output is float
const fetchMilkusagefactoForBatch = async (data) => {
    return fetchInfo('/batch/GetMilkusagefactor', data);
};

// data = equipmentid, batchid
// output is equipmentstepmodel
const fetchEquipmentSteps = async (data) => {
    return fetchInfo('/batch/GetEquipmentSteps', data);
};

// data = batchid
// output is equipmentstepmodel
const fetchPreviousEquipmentSteps = async (data) => {
    return fetchInfo('/batch/GetPreviousEquipmentSteps', data);
};

// data = equipmentstepmodel
// output is equipmentstepmodel
const storeEquipmentSteps = async (data) => {
    return await Api(store).put('/batch/storeEquipmentSteps', data);
};

// data = List<StepOstModel> lijstSteps
// output is List<StepOstModel> lijstSteps
const storeStepsForBatch = async (data) => {
    return await Api(store).put('/batch/StoreStepsForBatch', data);
};

// data = batchID
// output ok
const deleteEquipmentStepsFromBatch = async (data) => {
    return deleteInfo('/batch/DeleteEquipmentStepsFromBatch', data);
};

// data = bookdate
// output is
const fetchCheeseMarksForProdrun = async (data) => {
    return fetchInfo('/batch/GetBatchCheeseMarksInfo', data);
};

// data = batchID
// output is
const fetchCheeseMarksForBatch = async (data) => {
    return fetchInfo('/batch/GetCheeseMarks', data);
};

// data = productID
// output is
const fetchCheeseMarkType = async (data) => {
    return fetchInfo('/CheeseMark/GetCheeseMarkType', data);
};

// data = bookdate
// output is
const fetchProdRun = async (data) => {
    return fetchInfo('/batch/GetProdrun', data);
};

// data =  prodrunID, starterSubtypeProductID
// output is
const setStarterSubType = async (data) => {
    return storeInfo('/batch/StoreProdrunStarterSubtype', data);
};

// data = batchid
// output is
const fetchBatchActivityLog = async (data) => {
    return fetchInfo('/batch/GetBatchActivityLog', data);
};

// DateTime from, DateTime until max 10 dagen
const fetchInbrineDataAccepted = async (data) => {
    return fetchInfo('/datapoints/GetInBrineDataAccepted', data);
};

// DateTime from, DateTime until max 10 dagen
const fetchInbrineDataIgnored = async (data) => {
    return fetchInfo('/datapoints/GetInBrineDataIgnored', data);
};

// DateTime from, DateTime until max 10 dagen
const fetchInbrineDataToProcess = async (data) => {
    return fetchInfo('/datapoints/GetInBrineDataToProcess', data);
};

// data =  key, status
// output is
const setDataPointStatus = async (data) => {
    return storeInfo('/DataPoints/SetDataPointStatus', data);
};

// data = batchid
// output is
const fetchLinkedOstData = async (data) => {
    return fetchInfo('/batch/GetLinkedOstData', data);
};

const hasOstPLCdata = async (data) => {
    return fetchInfo('/batch/HasOSTData', data);
}

const unLinkStepsOst = async (data) => {
    return storeInfo('/batch/UnLinkOstData', data);
};

// data = batchID
// output is
const fetchOrderedAlternatives = async (data) => {
    return fetchInfo('/batch/GetOrderedAlternatives', data);
};

// data = batchid
const fetchBatchReportInfo = async (data) => {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Content-Disposition': 'attachment;'
    };
    const responseType = 'arraybuffer';
    return fetchInfoAtt(
        '/reporting/GetBatchReport',
        data,
        headers,
        responseType
    );
};

const fetchInfoAtt = async (apicall, data, headers, responsetype) => {
    if (data != undefined) {
        return await Api(store).get(
            apicall +
                '?' +
                Object.keys(data)
                    .map(
                        (k) =>
                            encodeURIComponent(k) +
                            '=' +
                            encodeURIComponent(data[k] ?? '')
                    )
                    .join('&'),
            {
                headers: headers,
                responseType: responsetype
            }
        );
    } else {
        return await Api(store).get(apicall, {
            headers: headers,
            responseType: responsetype
        });
    }
};

const fetchInfo = async (apicall, data) => {
    if (data != undefined) {
        return await Api(store).get(
            apicall +
                '?' +
                Object.keys(data)
                    .map(
                        (k) =>
                            encodeURIComponent(k) +
                            '=' +
                            encodeURIComponent(data[k] ?? '')
                    )
                    .join('&'),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    } else {
        return await Api(store).get(apicall, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }
};
const storeInfo = async (apicall, data) => {
    if (data != undefined) {
        return await Api(store).put(
            apicall +
                '?' +
                Object.keys(data)
                    .map(
                        (k) =>
                            encodeURIComponent(k) +
                            '=' +
                            encodeURIComponent(data[k] ?? '')
                    )
                    .join('&'),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    }
};
const deleteInfo = async (apicall, data) => {
    if (data != undefined) {
        return await Api(store).delete(
            apicall +
                '?' +
                Object.keys(data)
                    .map(
                        (k) =>
                            encodeURIComponent(k) +
                            '=' +
                            encodeURIComponent(data[k] ?? '')
                    )
                    .join('&'),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    }
};

export default {
    fetchBatch,
    fetchBatchQualityPrediction,
    deleteBatch,
    moveBatchToEnd,
    destroyBatch,
    updateBatch,
    addBatches,
    assignSalesOrder,
    setDataPointStatus,
    fetchProdRun,
    fetchStarterSubtypesForDay,
    setStarterSubType,
    fetchBatchInfo,
    fetchBatchInfoOverPeriod,
    fetchBatchIngredients,
    fetchBatchIngredient,
    fetchBatchDefaults,
    fetchAlternativeCheeseTypes,
    fetchMilkusagefactor,
    fetchMilkusagefactoForBatch,
    fetchMilkInfoForDay,
    addBatchIngredients,
    deleteBatchIngredient,
    updateBatchInBrine,
    fetchBatchInbrineAmounts,
    fetchEquipmentSteps,
    fetchPreviousEquipmentSteps,
    storeEquipmentSteps,
    storeStepsForBatch,
    deleteEquipmentStepsFromBatch,
    fetchCheeseMarksForProdrun,
    fetchCheeseMarksForBatch,
    fetchCheeseMarkType,
    setCheeseMarks,
    repairCheeseMarks,
    fetchBatchActivityLog,
    fetchInbrineDataAccepted,
    fetchInbrineDataIgnored,
    fetchInbrineDataToProcess,
    fetchLinkedOstData,
    hasOstPLCdata,
    unLinkStepsOst,
    fetchOrderedAlternatives,
    fetchBatchReportInfo
};

